import {lazy} from '@aboutyou/lazy-imports';

export const StreetwearPage = lazy(
  () =>
    import('./StreetwearPage.eager').then(mod => ({
      default: mod.StreetwearPage,
    })),
  {aboveTheFold: true, isSsrAndNeedsHydration: true},
);
